export const validateDates = (dateStart, dateEnd) => {
  if (!dateStart || !dateEnd) {
    return "Selecione as duas datas para filtrar";
  }

  const start = new Date(dateStart);
  const end = new Date(dateEnd);
  const today = new Date();

  // remove hora para evitar problema de timezone
  today.setHours(0, 0, 0, 0);

  if (start > today) {
    return "A data inicial não pode ser maior que hoje";
  }

  if (end > today) {
    return "A data final não pode ser maior que hoje";
  }

  if (start >= end) {
    return "A data inicial deve ser menor que a data final";
  }

  const diffDays = (end - start) / (1000 * 60 * 60 * 24);

  if (diffDays < 1) {
    return "Deve haver pelo menos 1 dia de diferença entre as datas";
  }

  if (diffDays > 365) {
    return "O intervalo entre as datas não pode ser maior que 1 ano";
  }

  return null; // válido
};
